import { AnimationTriggerMetadata } from '@angular/animations';
import { fmntsIconAnimations } from '@fmnts/components/icons';

export const fmntsSelectAnimations: {
  /** Animation to rotate the dropdown arrow icon */
  readonly rotateIcon: AnimationTriggerMetadata;
} = {
  rotateIcon: fmntsIconAnimations.rotateZ,
};
